interface BrandMarkProps {
  className?: string;
  size?: number;
}

/** PairBolt mark: pairing brackets + ember bolt. */
export function BrandMark({ className = "", size = 32 }: BrandMarkProps) {
  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src="/brand/mark.svg"
      alt=""
      width={size}
      height={size}
      decoding="async"
    />
  );
}
